import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const versionOpen = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:open`, 
        category: settings.categoryName 
    });
};

export default versionOpen;